declare interface reCaptchaWindow extends Window {
    readonly reCaptchaSiteKey?: string;
}
declare const window: reCaptchaWindow;

/**
 * TryReCaptchaToken mints a reCAPTCHA v3 token when the page has grecaptcha
 * loaded and a v3 site key configured. Resolves '' when the page has neither
 * (depot and ccn load no grecaptcha at all) or when Google is slow — a lead
 * submission must never block on, or be lost to, the captcha. Callers send
 * the token when they get one and omit it otherwise; the server treats it
 * accordingly (advisory for quote-request form submissions).
 */
export async function TryReCaptchaToken(action: string): Promise<string> {
    const siteKey = window.reCaptchaSiteKey;
    if (typeof grecaptcha === 'undefined' || !siteKey) {
        return '';
    }

    const token = new Promise<string>(resolve => {
        grecaptcha.ready(() => {
            grecaptcha.execute(siteKey, { action }).then(resolve, () => resolve(''));
        });
    });
    const timeout = new Promise<string>(resolve => setTimeout(() => resolve(''), 3000));
    return Promise.race([token, timeout]);
}
